export default __webpack_public_path__ + "static/individual.prinoth-6b62beb3e65c5684df2be1464c9374b8.png";